import styled from 'styled-components';
import {media} from '../../styles/components/media-queries';

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  ${p => p.theme.menuPage.menu.mobileMenuBackground && `background: ${p.theme.menuPage.menu.mobileMenuBackground}`};
  ${p => p.theme.menuPage.menu.mobileMenuTextColor && `background: ${p.theme.menuPage.menu.mobileMenuTextColor}`};
  ${media.small`
    display: ${p => p.theme.preferences.menuPage.showMobileMenuName ? 'block' : 'none'};
  `};
`;

export const Top = styled.div`
  width: 100%;
  height: 2.2rem;
  background-color: ${p => p.theme.menuPage.menu.backgroundColor};
  ${media.small`
    height: 1rem;
  `};
`;

export const NameWrapper = styled.div`
  font-size: 2rem;
  letter-spacing: 0.2rem;
  color: ${p => p.theme.primaryColor};
  height: 5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-transform: uppercase;
  position: relative;
  ${media.small`
    justify-content: ${p => p.theme.preferences.menuPage.showMobileMenuName ? 'center' : 'space-between'};
  `};
`;

export const Border = styled(Top)`
  height: 100%;
  width: 2.2rem;
  ${media.small`
    width: 1rem;
    display: ${p => p.theme.preferences.menuPage.showMobileMenuName ? 'none' : 'block'};
  `};
`;



// WEBPACK FOOTER //
// ./containers/MenuPage/MenuName.style.js